import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    REQUEST: createActionType(FULL_NAMESPACE, "REQUEST"),
    REQUEST_STARTED: createActionType(FULL_NAMESPACE, "REQUEST_STARTED"),
    REQUEST_INPROGRESS: createActionType(FULL_NAMESPACE, "REQUEST_INPROGRESS"),
    REQUEST_COMPLETED: createActionType(FULL_NAMESPACE, "REQUEST_COMPLETED"),
    REQUEST_REJECTED: createActionType(FULL_NAMESPACE, "REQUEST_REJECTED")
};
